var CommunicatorDetector = {
  hasActiveX: (window.ActiveXObject !== undefined),

  canDetectPlugins: function() {
    return ( CommunicatorDetector.hasActiveX || !!navigator.mimeTypes );
  },

  detectFlash: function() {
    var pluginFound = CommunicatorDetector.detectPluginByMIME('application/x-shockwave-flash');
    // if not found, try to initialize with ActiveX
    if(!pluginFound && CommunicatorDetector.hasActiveX) {
      pluginFound = CommunicatorDetector.detectActiveXControl('ShockwaveFlash.ShockwaveFlash.1');
    }
    return pluginFound;
  },

  detectGarminCommunicatorPlugin: function() {
    var pluginFound = CommunicatorDetector.detectPluginByMIME('application/vnd-garmin.mygarmin');
    // if not found, try to initialize with ActiveX
    if(!pluginFound && CommunicatorDetector.hasActiveX) {
      pluginFound = CommunicatorDetector.detectActiveXControl('GARMINAXCONTROL.GarminAxControl_t.1');
    }
    return pluginFound;
  },

  detectPluginByMIME: function(mimeTypeName) {
    if (navigator.mimeTypes) {
      var mimeType = navigator.mimeTypes[mimeTypeName];
      return !!(mimeType && mimeType.enabledPlugin);
    }
    else {
      return false;
    }
  },

  detectActiveXControl: function(activeXControlName) {
    try {
      var control = new window.ActiveXObject(activeXControlName);
      if(control) return true;
    }
    catch (e) {
      return false;
    }
  }
}

module.exports = CommunicatorDetector



// WEBPACK FOOTER //
// ./public/javascripts/communicator_detector.js